import { useRef } from 'react';
import { useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import ConfigsService from "../../Services/ConfigurationService";
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';

function CreateConfig(props) {
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    const configKeyInputRef = useRef();
    const configValueInputRef = useRef();

    function loadConfigValues() {
        var configKey = $('#configKey').val();
        var data = [];
        if (configKey == "DeviceCrtStorageOption") {
            data = ["FileSystem", "TPM", "Registry"];
        } else if (configKey == "KeyCombination") {
            data = ["PerSBI", "PerModality"];
        }

        var configValue = "<select id='configValue'>" + '<option value="null" selected disabled>-Select-</option>';

        for (var i = 0; i < data.length; i++) {
            configValue = configValue + '<option value=' + data[i] + '>' + data[i] + '</option>';
        }

        configValue = configValue + '</select>';
        $('#configValue').html(configValue);
    }

    function resetHandler() {
        configKeyInputRef.current.value = "";
        configValueInputRef.current.value = "";

        loadConfigValues();
    }

    function createHandler(event) {
        event.preventDefault();

        const enteredConfigKey = configKeyInputRef.current.value;
        const enteredConfigValue = configValueInputRef.current.value;

        var configDTO = {
            ConfigKey: enteredConfigKey,
            ConfigValue: enteredConfigValue
        };

        ConfigsService.createConfig(configDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                } else {
                    props.onClose();
                    props.onShowMessage("Configuration created sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Add Configuration</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={createHandler}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="ConfigKey" className="label">Config Key</label>
                            <div>
                                <select id="configKey" className="InputField" ref={configKeyInputRef} onLoad={loadConfigValues} onChange={loadConfigValues} required>
                                    <option value="" selected>-Select-</option>
                                    <option value="DeviceCrtStorageOption">DeviceCrtStorageOption</option>
                                    <option value="KeyCombination">KeyCombination</option>
                                </select>
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="ConfigValue" className="label">Config Value</label>
                            <div>
                                <select id="configValue" className="InputField" ref={configValueInputRef} required>
                                    <option value="" selected disabled>-Select-</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={resetHandler}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><AddIcon /></span>
                                <span className="primary-button-text">Add Config</span>
                            </button>

                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>

        </Modal >
        //<div className={classes.container}>
        //    <h1 className="display-5">Create Config</h1>
        //    {config == "created" && <MessagePopup title="Success" body={message} />}
        //    {config == "failed" && <MessagePopup title="Failure" body={error} />}
        //    <form onSubmit={createHandler}>
        //        <div>
        //            <label className="control-label required">ConfigKey</label>
        //            <div className="form-group">
        //                <select id="configKey" className="form-control" aria-label="Default select example" aria-haspopup="true" aria-expanded="false"
        //                    ref={configKeyInputRef} onLoad={loadConfigValues} onChange={loadConfigValues} required>
        //                    <option value="null" selected disabled>-Select-</option>
        //                    <option value="DeviceCrtStorageOption">DeviceCrtStorageOption</option>
        //                    <option value="KeyCombination">KeyCombination</option>
        //                </select>
        //            </div>
        //            <label className="control-label required">ConfigValue</label>
        //            <div className="form-group">
        //                <select id="configValue" className="form-control" aria-haspopup="true" aria-expanded="false" aria-label="Default select example" ref={configValueInputRef} required>
        //                </select>
        //            </div>
        //        </div><br />
        //        <div>
        //            <button className="btn btn-primary ">Create</button>&nbsp;
        //            <Link to='/configurations'><button type="button" className="btn btn-outline-dark">Back</button></Link>
        //        </div>
        //    </form>
        //</div>
    );
}

export default CreateConfig;